/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState } from "react";
import PatientEngagementModal from "../MissedAndDueList/PatientEngagementModal";
import "./tasks.css";
import TasksForm from "./TasksForm";
import dayjs from "dayjs";

const TasksRow = ({ data, setInitialOffset }) => {
  const [isEdit, setIsEdit] = useState(false);
  const [displayModal, setDisplayModal] = useState(false);
  const defaultDateFormat = "MM/DD/YY h:mm:ss a";

  const closeModal = (shouldRefresh) => {
    if (shouldRefresh) {
      setInitialOffset(true);
    }
    setDisplayModal(false);
  };

  if (isEdit) {
    return (
      <tr>
        <td colSpan={7}>
          <TasksForm
            initialNote={data?.taskInitialNote}
            endNote={data?.taskEndNote}
            initDevice={data?.deviceSerialNumber}
            initReason={data?.taskReason}
            isEditing={true}
            isClosed={data?.taskStatus === "CLOSED"}
            assigned={
              data?.taskAssigned && `${data?.taskAssignUserLastName}, ${data?.taskAssignUserFirstName}`
            }
            submittedBy={
              `${data?.creatorUserLastName}, ${data?.creatorUserFirstName}`
            }
            setIsEditing={setIsEdit}
            taskId={data?.taskId}
            refresh={closeModal}
          />
        </td>
      </tr>
    );
  }

  return (
    <>
      <tr>
        <td>{dayjs.unix(data?.taskCreatedDate).format(defaultDateFormat)}</td>
        <td>{data?.creatorUserLastName}, {data?.creatorUserFirstName}</td>
        <td>{data?.taskReason}</td>
        <td>
          {data?.deviceType} - {data?.deviceSerialNumber}
        </td>
        <td className="preview-task-note">{data?.taskEndNote || data?.taskInitialNote}</td>
        <td>{data?.taskClosedDate && dayjs.unix(data?.taskClosedDate).format(defaultDateFormat)}</td>
        <td>
          {data.taskAssignUserLastName || data.taskAssignUserFirstName ? (
            `${data.taskAssignUserLastName}, ${data.taskAssignUserFirstName}`
          ) : null}
        </td>
        <td style={{ width: "1%" }}>
          <div className="show-options-tasks">
            <a id="viewEditBtnId" onClick={() => setIsEdit(true)} className="btn btnTeal">
              View/Edit
            </a>
            {data?.taskStatus === "OPEN" && (
              <a
                id="createIRBtnId"
                className="btn btnTeal"
                onClick={() => {
                  setDisplayModal(true);
                }}
              >
                Open Task
              </a>
            )}
          </div>
        </td>
      </tr>
      {displayModal ? (
        <PatientEngagementModal task={data} onClose={closeModal} refresh={() => setInitialOffset(true)} />
      ) : null}
    </>
  );
};
export default TasksRow;
